@if (show) {
<div [class.ouvert]="panelOuvert" [class.ferme]="!panelOuvert" class="side-panel">
  <button nbButton status="info" class="open-panel-button" [style.left]="panelOuvert ? '-65px' : '-110px'"
    (click)="togglePanel()">
    {{ panelOuvert ? 'Réduire' : 'Voir la disposition' }}
  </button>
  <!-- Conteneur Swapy : il contiendra tous les slots et items -->
  @if (panelOuvert) {
  <div style="margin-top: 5px;text-align: center;">
    <nb-checkbox status="basic" size="tiny" [(checked)]="applyDiscount"
      (checkedChange)="applyDiscountChange.emit($event)">
      Ajouter les remises sur les visuels produits</nb-checkbox>
  </div>
  <div class="global-link">
    <nb-checkbox status="basic" size="tiny" [(checked)]="applyGlobalLink"
      (checkedChange)="applyGlobalLinkChange.emit($event)">
      Appliquer un lien unique à tous les visuels</nb-checkbox>
    @if (applyGlobalLink) {
    <input nbInput fieldSize="tiny" type="url" placeholder="https://..." class="global-link-input"
      [status]="globalLinkUrl && !isGlobalLinkUrlValid() ? 'danger' : 'basic'"
      [nbTooltip]="'L’URL doit commencer par http:// ou https://'" nbTooltipStatus="danger"
      [nbTooltipDisabled]="!globalLinkUrl || isGlobalLinkUrlValid()"
      [(ngModel)]="globalLinkUrl" (ngModelChange)="globalLinkUrlChange.emit($event)">
    }
  </div>
  }
  <div #swapyContainer class="swapy-container">
    @for (item of correctPosition(dashboard); track trackByItem($index, item)) {
    <div class="swapy-slot" [attr.data-swapy-slot]="item.ordre_generation" [style.grid-column-start]="(item.x ?? 0) + 1"
      [style.grid-row-start]="(item.y ?? 0) + 1" [style.grid-column-end]="'span ' + (item.cols ?? 1)"
      [style.grid-row-end]="'span ' + (item.rows ?? 1)">
      <div [attr.data-swapy-item]="getSlotName(item)" class="swapy-item">
        <div class="item-container" (mouseenter)="preloadNeighbors(item)">
          @if (getImageList(item); as imageList) {
          <div class="image-slider">
            <div class="slider-track" [class.no-transition]="disableTransition[item.instance_id]"
              [style.transform]="'translateX(-' + ((currentImageIndexes[item.instance_id] || 0) * 100) + '%)'">
              @for (imgSrc of getImageList(item); track $index) {
              <div class="slider-image-container">
                @if (!isCarrousel(imgSrc)) {
                <img [src]="getImageSrc(imgSrc)" class="slider-image" loading="lazy" />
                } @else {
                <img [src]="getImageSrc(getFirstImageFromCarrousel(imgSrc))" class="slider-image" loading="lazy" />
                }
              </div>
              }
            </div>

            <!-- Overlays (Flags, Watermarks, etc.) -->
            <!-- Note: Logic for 'isCarrousel' watermark depends on CURRENT image. We can check getCurrentImage(item) logic or just check the item at current index -->
            @if (isCarrousel(getImageList(item)[currentImageIndexes[item.instance_id] || 0])) {
            <div class="carrousel-watermark">Carrousel</div>
            }

            <div class="flags">
              @if (item.product_id && item.label) {
              <div class="flag deebr">{{ item.label }}</div>
              }
            </div>
            @if (item.product_id && item.discount_pct && applyDiscount) {
            <div class="flag-remise">{{ item.discount_pct }} %</div>
            }

            @if (imageList.length > 1) {
            <button class="slider-arrow left-arrow" (click)="previousImage($event, item)"
              (mousedown)="$event.stopPropagation()" (pointerdown)="$event.stopPropagation()"
              (dragstart)="$event.preventDefault()">
              &#10094;
            </button>
            <button class="slider-arrow right-arrow" (click)="nextImage($event, item)"
              (mousedown)="$event.stopPropagation()" (pointerdown)="$event.stopPropagation()"
              (dragstart)="$event.preventDefault()">
              &#10095;
            </button>
            }
            @if (imageList.length > 0) {
            <div class="slider-dots-container">
              <div class="slider-dots">
                @for (image of imageList; track image; let i = $index) {
                <span class="dot" [class.active]="i === (currentImageIndexes[item.instance_id] || 0)"
                  (click)="selectImage($event, item, i)" (mousedown)="$event.stopPropagation()"
                  (pointerdown)="$event.stopPropagation()" (dragstart)="$event.preventDefault()"></span>
                }
                <span [nbSpinner]="loadingImages[item.product_id!]" nbSpinnerSize="tiny" nbSpinnerStatus="control"
                  class="dot-spinner"></span>
              </div>
            </div>
            }
          </div>
          }
          @if (item && item.product_id && !isGifImage(getCurrentImage(item))) {
          <i class="bi bi-filetype-gif gif-image" (click)="createGif($event, item)"
            nbTooltip="Créer un GIF ou un Carrousel avec vos images" nbTooltipStatus="warning"></i>
          }
          @if (item && item.product_id) {
          <nb-icon class="upload-image" icon="camera-outline" (click)="onButtonClick($event, item)"
            nbTooltip="Remplacer cette image avec une image de votre ordinateur." nbTooltipStatus="info"></nb-icon>
          }
          @if (item && item.product_id) {
          <nb-icon class="remove-button" icon="trash-2-outline" (click)="removeProduct(item)"
            nbTooltip="Désélectionner ce produit" nbTooltipStatus="danger"></nb-icon>
          }
          <input id="file-upload-drag-and-drop" type="file" style="display:none;" (click)="setClickedProduct(item)"
            (change)="onFileSelected($event)">
        </div>
      </div>
    </div>
    }
  </div>
</div>
}

<app-create-gif-product [show]="showCreateGif" (closeRequest)="handleCloseRequest()"
  (gifCreated)="handleGifCreated($event)" (carrouselCreated)="handleCarrouselCreated($event)">
</app-create-gif-product>

<ng-template #dialogUploadImage let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-body class="text-center">
      {{ errorMessage }}
    </nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col text-center">
          <button nbButton status="danger" (click)="ref.close()">OK</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>